var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 7.97638C9.0287 7.97638 8.6726 8.12388 8.41005 8.38643C8.1475 8.64898 8 9.00508 8 9.37638C8 9.74768 8.1475 10.1038 8.41005 10.3663C8.6726 10.6289 9.0287 10.7764 9.4 10.7764H20.6C20.9713 10.7764 21.3274 10.6289 21.59 10.3663C21.8525 10.1038 22 9.74768 22 9.37638C22 9.00508 21.8525 8.64898 21.59 8.38643C21.3274 8.12388 20.9713 7.97638 20.6 7.97638H9.4ZM8 15.0002C8 14.6289 8.1475 14.2728 8.41005 14.0102C8.6726 13.7477 9.0287 13.6002 9.4 13.6002H20.6C20.9713 13.6002 21.3274 13.7477 21.59 14.0102C21.8525 14.2728 22 14.6289 22 15.0002C22 15.3715 21.8525 15.7276 21.59 15.9901C21.3274 16.2527 20.9713 16.4002 20.6 16.4002H9.4C9.0287 16.4002 8.6726 16.2527 8.41005 15.9901C8.1475 15.7276 8 15.3715 8 15.0002ZM9.4 19.224C9.0287 19.224 8.6726 19.3715 8.41005 19.634C8.1475 19.8966 8 20.2527 8 20.624C8 20.9953 8.1475 21.3514 8.41005 21.6139C8.6726 21.8765 9.0287 22.024 9.4 22.024H20.6C20.9713 22.024 21.3274 21.8765 21.59 21.6139C21.8525 21.3514 22 20.9953 22 20.624C22 20.2527 21.8525 19.8966 21.59 19.634C21.3274 19.3715 20.9713 19.224 20.6 19.224H9.4Z",
    fill: "#222222",
    stroke: "#F8F8F8",
    strokeWidth: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 15C29 22.7322 22.7322 29 15 29C7.2678 29 1 22.7322 1 15C1 7.2678 7.2678 1 15 1C22.7322 1 29 7.2678 29 15ZM26.2 15C26.2 17.9704 25.02 20.8192 22.9196 22.9196C20.8192 25.02 17.9704 26.2 15 26.2C12.0296 26.2 9.18081 25.02 7.0804 22.9196C4.98 20.8192 3.8 17.9704 3.8 15C3.8 12.0296 4.98 9.18081 7.0804 7.0804C9.18081 4.98 12.0296 3.8 15 3.8C17.9704 3.8 20.8192 4.98 22.9196 7.0804C25.02 9.18081 26.2 12.0296 26.2 15Z",
    fill: "#222222",
    stroke: "#F8F8F8",
    strokeWidth: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSidebar);
export default __webpack_public_path__ + "static/media/open_sidebar.c9adf72eb164cfc7f0631ef105064ae7.svg";
export { ForwardRef as ReactComponent };